export default __webpack_public_path__ + "static/chess-ad6481379237da71d684590a7e5fcfb5.webp";